import { useEffect, useState } from 'react';
import { useApiFetch } from './useApiFetch';

interface UseEvalSetConfigResult {
  config: Record<string, unknown> | null;
  isLoading: boolean;
  error: Error | null;
}

export function useEvalSetConfig(
  evalSetId: string | null
): UseEvalSetConfigResult {
  const [config, setConfig] = useState<Record<string, unknown> | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { apiFetch, error } = useApiFetch();

  useEffect(() => {
    if (!evalSetId) return;

    let cancelled = false;

    (async () => {
      setIsLoading(true);
      const response = await apiFetch(`/eval_sets/${evalSetId}/config`);
      if (cancelled) return;
      if (response) {
        const data: unknown = await response.json();
        if (!cancelled && data && typeof data === 'object') {
          setConfig(data as Record<string, unknown>);
        }
      }
      setIsLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [evalSetId, apiFetch]);

  return { config, isLoading, error };
}
